import { Typography, Box } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBullhorn } from "@fortawesome/pro-solid-svg-icons"
import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"

const useStyles = makeStyles()(() => ({
    card: {
        backgroundColor: "#FFF4E5",
        color: "#663C00",
        padding: "1rem",
        borderRadius: ".5rem",
        display: "flex",
        flexDirection: "column",
        gap: ".5rem",
        marginBottom: "1rem",
    },
    header: {
        display: "flex",
        alignItems: "center",
        gap: ".5rem",
        fontWeight: "bold",
    },
    footer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "end",
        fontWeight: "bold",
        cursor: "pointer",
    },
}))

export function CheckInReminderCard({ onLearnMoreClick }: { onLearnMoreClick: () => void }) {
    const { classes } = useStyles()

    return (
        <Box className={classes.card}>
            <Box className={classes.header}>
                <LocalizedStrict id="user-home-upcoming-purchases-check-in-reminder">
                    <Typography variant="subtitle1" fontWeight="bold">
                        Check-in reminder
                    </Typography>
                </LocalizedStrict>
                <FontAwesomeIcon icon={faBullhorn} />
            </Box>
            <LocalizedStrict id="user-home-upcoming-purchases-check-in-subtitle">
                <Typography variant="body2">Remember to check into the canteen today.</Typography>
            </LocalizedStrict>

            {/* <Box className={classes.footer}>
                <LocalizedStrict id="user-home-upcoming-purchases-learn-more">
                    <Typography variant="body2">Learn more</Typography>
                </LocalizedStrict>
                <IconButton onClick={onLearnMoreClick} size="small" style={{ color: "#6B4226" }}>
                    <FontAwesomeIcon size="xs" icon={faChevronRight} />
                </IconButton>
            </Box> */}
        </Box>
    )
}
